import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { KeycloakAngularModule, KeycloakBearerInterceptor, KeycloakService } from '@inoventoryapps/keycloak-angular';
import { NgxUiLoaderConfig, NgxUiLoaderHttpModule, NgxUiLoaderModule } from 'ngx-ui-loader';
import { AppRoutingModule } from './app-routing.module';
import { PrimrngModule } from './shared/primrng.module';
import { SharedModule } from './shared/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginatorModule } from '@angular/material/paginator';


import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule, HttpClientXsrfModule, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import Lara from '@primeng/themes/lara';
import { providePrimeNG } from 'primeng/config';
import { AppComponent } from './app.component';
import { CustomMenuItemComponent } from './custom-side-nav/custom-menu-item/custom-menu-item.component';
import { CustomSideNavComponent } from './custom-side-nav/custom-side-nav.component';
import { authInterceptor } from './interceptor/auth.interceptor';
import { initializeKeycloak } from './keyclock/keycloak-init.factory';
import { NavStripComponent } from './nav-strip/nav-strip.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { ConfirmationDialogComponent } from './custom/confirmation-dialog/confirmation-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { RolesComponent } from './roles/roles.component';
import { ActionRolesComponent } from './master/action-roles/action-roles.component';
import { KeyService } from './services/key.service';
import { EncryptionInterceptor } from './interceptor/encryption.interceptor';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
    bgsSize: 0,
    fgsSize: 0,
    hasProgressBar: false,
    logoUrl: 'https://cdn.lokos.in/lokos-in/assets/LokOS-Circle-Animation.gif',
    overlayColor: 'transparent'
};

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}


export function InitIndexDB(keyService: KeyService) {
    return () => {
        return keyService.initDB();
    };
}

@NgModule({
    declarations: [
        AppComponent,
        NavStripComponent,
        ToolbarComponent,
        CustomMenuItemComponent,
        ConfirmationDialogComponent,
        RolesComponent,
        ActionRolesComponent
    ],
    imports: [
        AppRoutingModule,
        BrowserAnimationsModule,
        BrowserModule,
        KeycloakAngularModule,
        CustomSideNavComponent,

        NgxUiLoaderHttpModule.forRoot({ showForeground: true }),
        NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
        PrimrngModule,
        ReactiveFormsModule,
        FormsModule,
        MatFormFieldModule,
        SharedModule,
        MatPaginatorModule,
        MatIconModule,
        MatButtonModule,
        MatMenuModule,
        MatTableModule,
        MatSortModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        FormsModule,
        MatDialogModule,
        HttpClientModule,
        HttpClientXsrfModule.withOptions({
            cookieName: 'XSRF-TOKEN',
            headerName: 'X-XSRF-TOKEN'
        })
    ],
    providers: [
        provideAnimations(),
        provideAnimationsAsync(),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: EncryptionInterceptor,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi(), withInterceptors([authInterceptor])),
        providePrimeNG({ theme: { preset: Lara } }),
        {
            deps: [KeycloakService],
            multi: true,
            provide: APP_INITIALIZER,
            useFactory: initializeKeycloak
        },
        {
            multi: true,
            provide: HTTP_INTERCEPTORS,
            useClass: KeycloakBearerInterceptor
        },
        {
            deps: [KeyService],
            multi: true,
            provide: APP_INITIALIZER,
            useFactory: InitIndexDB
        },


    ],
    bootstrap: [AppComponent],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,

    ]
})
export class AppModule { }
